<app-maintenance-mode-alert></app-maintenance-mode-alert>
<app-location-context-panel></app-location-context-panel>

<!-- Content -->
<div class="content">
    <mat-card>
        <mat-card-content>
            <div class="container">
                <h1>Statistics</h1>
                <div class="statistics">
                    <div class="statistic" *ngFor="let statistic of statistics$ | async">
                        <div class="field label">{{ statistic.statistic }}</div>
                        <div class="field value">{{ statistic.measurement }} {{ statistic.unit }}</div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>